import * as style from "./Heading.css";

export const h1 = (props: Object) => <h1 className={style.h1} {...props} />;

export const h2 = (props: Object) => <h2 className={style.h2} {...props} />;

export const h3 = (props: Object) => <h3 className={style.h3} {...props} />;

export const h4 = (props: Object) => <h4 className={style.h4} {...props} />;
